export const EDUCATION_LEVELS = ['中职', '高职', '职教本科'] as const
export type EducationLevel = (typeof EDUCATION_LEVELS)[number]

export const NODE_STAGE1 = 'stage1.preconditions'
export const NODE_STAGE2 = 'stage2.job_goals'
export const NODE_STAGE3 = 'stage3.industry'
export const NODE_STAGE4_OPTIONS = 'stage4.path_options'
export const NODE_STAGE4_SELECTED = 'stage4.selected_project'
export const NODE_STAGE5 = 'stage5.learning_situations'
export const NODE_STAGE6_PREFIX = 'stage6.practice.'
export const NODE_STAGE7 = 'stage7.evaluation'
export const NODE_LESSON_PLAN = 'artifact.lesson_plan'
export const NODE_PPT_OUTLINE = 'artifact.ppt_outline'
export const NODE_LECTURE_NOTES = 'artifact.lecture_notes'

export const STAGE_PRIMARY_NODE: Record<number, string> = {
  1: NODE_STAGE1,
  2: NODE_STAGE2,
  3: NODE_STAGE3,
  4: NODE_STAGE4_SELECTED,
  5: NODE_STAGE5,
  7: NODE_STAGE7,
}

export function stage6Key(index: number): string {
  return `${NODE_STAGE6_PREFIX}${index}`
}

export function normalizeEducationLevel(raw: unknown): EducationLevel | null {
  const text = String(raw ?? '').trim()
  if (text === '中职' || text === '高职' || text === '职教本科') return text
  if (text === '专科' || text === '高职专科') return '高职'
  if (text === '职本' || text === '职业本科') return '职教本科'
  return null
}
